import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M1.667 7 3.42 3.992A2 2 0 0 1 5.15 3h5.702a2 2 0 0 1 1.728.992L14.333 7M1.667 7H.333m1.334 0v5a1 1 0 1 0 2 0v-.333h8.666V12a1 1 0 1 0 2 0V7m0 0h1.334m-12 1.333H5m6 0h1.333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgCar;
